import getConfig from "./app.config";

const getEnvironmentConfig = (currentEnv) => {
  const environments = {
    dev: getConfig(process.env.REACT_APP_DEV_GETWAY, currentEnv),
    qa: getConfig(process.env.REACT_APP_QA_GETWAY, currentEnv),
    uat: getConfig(process.env.REACT_APP_UAT_GETWAY, currentEnv),
    prod: getConfig(process.env.REACT_APP_PROD_GETWAY, currentEnv),
  };
  return environments[currentEnv];
};

const environmentConfig = getEnvironmentConfig(
  process.env.REACT_APP_ENV || "dev"
);

export default environmentConfig;
